import { AxiosRequestConfig } from "axios";
import { softValidateResponse } from "@/server/validation";
import { instance } from "../api-instance";
import {
  GetInnVerificationResponseSchema,
  RedirectToLkResponseSchema,
  SelectAndActualizeByAmountResponseSchema,
  SelectAndActualizeResponseSchema,
} from "./schemas";

export const AccountApi = {
  accountSignIn(data: unknown): Promise<unknown> {
    return instance.post(`account/signIn`, data).then((res) => res.data);
  },

  redirectToLk(url: unknown) {
    return instance
      .post(`account/redirectToLk`, url)
      .then(softValidateResponse(RedirectToLkResponseSchema))
      .then((res) => res.data);
  },

  selectAndActualize(id: string, options: AxiosRequestConfig) {
    return instance
      .post(
        "additionalProduct/selectAndActualize",
        {
          applicationId: id,
        },
        options
      )
      .then(softValidateResponse(SelectAndActualizeResponseSchema))
      .then((res) => res.data);
  },

  selectAndActualizeByAmount(
    {
      applicationId,
      offerSum,
    }: {
      applicationId: string;
      offerSum: number;
    },
    options: AxiosRequestConfig
  ) {
    return instance
      .post(
        "additionalProduct/SelectAndActualizeByAmount",
        {
          applicationId,
          offerSum,
        },
        options
      )
      .then(softValidateResponse(SelectAndActualizeByAmountResponseSchema))
      .then((res) => res.data);
  },

  getEsiaPersonalData(esiaInfoId: string): Promise<unknown> {
    return instance
      .get(`personalData/getEsiaPersonalData?esiaInfoId=${esiaInfoId}`)
      .then((res) => res.data);
  },

  getTinkoffPersonalData(tinkoffTraceId: string): Promise<unknown> {
    return instance
      .get(
        `personalData/getTinkoffIDPersonalData?tinkoffTraceId=${tinkoffTraceId}`
      )
      .then((res) => res.data);
  },

  getPersonalData(): Promise<unknown> {
    return instance.get("personalData/get").then((res) => res.data);
  },

  findFirstName(name: unknown): Promise<unknown> {
    return instance.post("name/findFirstName", name).then((res) => res.data);
  },

  findLastName(name: unknown): Promise<unknown> {
    return instance.post("name/findLastName", name).then((res) => res.data);
  },

  findMiddleName(name: unknown): Promise<unknown> {
    return instance.post("name/findMiddleName", name).then((res) => res.data);
  },

  findFullName(name: unknown): Promise<unknown> {
    return instance.post("name/findFullName", name).then((res) => res.data);
  },

  checkCaptcha(value: unknown): Promise<unknown> {
    return instance
      .post("recaptcha/checkCaptcha", value)
      .then((res) => res.data);
  },

  usePromoCode(data: unknown): Promise<unknown> {
    return instance.post("account/usePromoCode", data).then((res) => res.data);
  },

  getPromocodeInfo(applicationId: string): Promise<unknown> {
    return instance
      .get(`account/getPromoInfo?applicationId=${applicationId}`)
      .then((res) => res.data);
  },

  cancelPromocode(applicationId: string): Promise<unknown> {
    return instance
      .post(`account/cancelPromocode`, { applicationId })
      .then((res) => res.data);
  },

  sendCodeDoUprid(data: unknown): Promise<unknown> {
    return instance.post("account/doUprid", data).then((res) => res.data);
  },

  checkUpridCode(data: unknown): Promise<unknown> {
    return instance
      .post("account/checkUpridCode", data)
      .then((res) => res.data);
  },

  getInnVerification() {
    return instance
      .get("innVerification/get")
      .then(softValidateResponse(GetInnVerificationResponseSchema))
      .then((res) => res.data);
  },

  saveManualInn(data: unknown): Promise<unknown> {
    return instance
      .post("innVerification/saveManualInn", data)
      .then((res) => res.data);
  },
};
